import script from "./KakaoPostModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KakaoPostModal.vue?vue&type=script&setup=true&lang=js"

import "./KakaoPostModal.vue?vue&type=style&index=0&id=766d8006&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../jump-dev-merge/서버/jump/jump-user/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-766d8006"]])

export default __exports__